import * as React from "react";

import { cn } from "./utils";

interface InputProps extends Omit<React.ComponentProps<"input">, "maxLength"> {
  maxLength?: number;
}

function Input({ className, type, maxLength, ...props }: InputProps) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "flex h-10 w-full min-w-0 rounded-lg border border-border bg-input-background px-3 py-2 text-base transition-[color,box-shadow] outline-none",
        "file:inline-flex file:h-10 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",
        "placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground",
        "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
        "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
        "disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
        "dark:bg-input/30",
         "md:text-sm",
        className,
      )}
      maxLength={maxLength}
      {...props}
    />
  );
}

export { Input };
